import React from 'react'
import { Checkbox, Dropdown, Input, TextArea } from 'semantic-ui-react'

import { buildSurveySelectorValue, findSelectedSurvey } from './utils'

export function VariableFieldValue({ row, onChange, isDisabled }) {
  if (row.MappingType !== 'StaticValue') {
    return null
  }

  const commonProps = {
    name: row.DisplayName,
    value: row.Value,
    disabled: isDisabled,
    required: row.Field.IsOptional === false,
    onChange: (_, { value }) => onChange(value),
  }

  const surveys = row.Field.Surveys || []
  const surveyOptions = surveys.map((survey) => ({
    key: survey.token,
    value: survey.token,
    text: survey.name,
  }))
  const selectedSurvey = findSelectedSurvey(surveys, row.Value)

  const fieldComponents = {
    text: <Input {...commonProps} type="text" fluid />,
    number: <Input {...commonProps} type="number" fluid />,
    boolean: (
      <Checkbox
        {...commonProps}
        toggle
        checked={row.Value == 'true'}
        onChange={(_, { checked }) => {
          const castString = String(checked)
          onChange(castString)
        }}
      />
    ),
    textarea: <TextArea {...commonProps} type="text" fluid />,
    survey_selector: (
      <Dropdown
        name={row.DisplayName}
        value={selectedSurvey ? selectedSurvey.token : null}
        disabled={isDisabled}
        selection
        fluid
        search
        placeholder="Select a survey"
        options={surveyOptions}
        onChange={(_, { value }) => {
          const survey = surveys.find((option) => option.token === value)
          onChange(buildSurveySelectorValue(survey))
        }}
      />
    ),
  }

  return fieldComponents[row.Field.DataType] || null
}



// WEBPACK FOOTER //
// ./src/components/CyclrCustomFieldForm/Variables/VariableFieldValue.tsx